import React, { useEffect, useState } from "react";
import "./Cancel_order.css";
import Breadcrumb_comp from "../../common-components/breadcrumb-comp/Breadcrumb_comp";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { Link, useParams } from "react-router-dom";
import Order_list_table from "./order_list_table/Order_list_table";
import Select_reason_heading from "../../common-components/select_reason_heading/Select_reason_heading";
import Reason_cancelling_field_holder from "../../common-components/reason_cancelling_field_holder/Reason_cancelling_field_holder";
import {
  decodeId,
  encodeId,
  formatDateTime,
  variant_type,
} from "../../../utils/common";
import { useDispatch, useSelector } from "react-redux";
import { getOrder, getOrderDetail } from "../../../features/order/orderSlice";
import {
  appSetup,
  getAllCancelReason,
  getAllReplaceReason,
  getAllReturnReason,
} from "../../../features/master/masterSlice";
import Replace_Order_list_table from "./replace_order_list_table/Replace_Order_list_table";
import { getProduct } from "../../../features/products/productsSlice";
import { useNavigate } from "react-router-dom";

function Replace_order({ avg_rating }) {
  const { id } = useParams(); // encoded ID from URL
  const [orderId, setOrderId] = useState(null); // decoded ID

  const [selectedVariant, setSelectedVariant] = useState("");
  const [activeSize, setActiveSize] = useState("");

  const [activeMetal, setActiveMetal] = useState("");
  const [activeTriple, setActiveTriple] = useState("");
  useEffect(() => {
    if (id) {
      const decoded = decodeId(id);
      setOrderId(decoded);
    }
  }, [id]);

  const [cancelReason, setCancelReason] = useState();
  const [cancelReasonId, setCancelReasonId] = useState(null);
  const [cancelReasonName, setCancelReasonName] = useState("");
  const [selectedItems, setSelectedItems] = useState([]);
  const dispatch = useDispatch();

  const navigate = useNavigate();

  const order = useSelector((state) => state.order.order_detaill);
  useEffect(() => {
    if (orderId) {
      // Ensure ID is valid before dispatching
      dispatch(getOrderDetail({ id: orderId, order_status_id: "" }));
    }
  }, [dispatch, orderId]);

  const product = useSelector((state) => state.product.product);

  // useEffect(() => {
  //   if (order) {
  //     dispatch(getProduct(order?.product_id));
  //   }
  // }, [dispatch, order]);

  useEffect(() => {
    if (order?.product_id) {
      dispatch(getProduct(order.product_id));
    }
  }, [dispatch, order?.product_id]);

  const breadcrumbs = [
    { label: "Home", link: "/", isActive: false },
    { label: "MY ORDERS", link: "/account", isActive: false },
    {
      label: "ORDER DETAILS",
      link: `/order-details/${encodeId(order?.id)}`,
      isActive: false,
    },
    { label: "REPLACE ORDER", link: "", isActive: true },
  ];

  // const [error, setError] = useState(false);
  const [error, setError] = useState({
  reason: "",
  product: "",
  variant: "",
});

  const reason = useSelector((state) => state.master.replaceReasons);
  useEffect(() => {
    // Ensure ID is valid before dispatching
    dispatch(getAllReplaceReason());
  }, [dispatch]);
  const appSetupdata = useSelector((state) => state.master.app_setup);

  // useEffect(() => {
  //   // Ensure ID is valid before dispatching
  //   dispatch(appSetup());
  // }, [dispatch]);

  // Auto select first available variant
  // useEffect(() => {
  //   let firstMetal;
  //   let firstSize;
  //   let firstTriple;
  //   if (Number(product.variant_type_id) === variant_type.Single) {
  //     firstMetal = product?.Product_Variants?.[0];
  //   } else if (Number(product.variant_type_id) === variant_type.Double) {
  //     firstMetal = product?.Product_Variants?.[0];
  //     firstSize = firstMetal?.Double_Variants?.[0];
  //   } else if (Number(product.variant_type_id) === variant_type.Triple) {
  //     firstMetal = product?.Product_Variants?.[0];
  //     firstSize = firstMetal?.Double_Variants?.[0];
  //     firstTriple = firstSize?.Triple_Variants?.[0] || null;
  //   }

  //   setActiveMetal(firstMetal || null);
  //   setActiveSize(firstSize || null);
  //   setActiveTriple(firstTriple || null);
  //   setSelectedVariant(firstTriple || firstSize || firstMetal);
  // }, [product]);

  // Auto select first available variant
  // useEffect(() => {
  //   if (!product?.Product_Variants?.length) return;

  //   let firstMetal = null;
  //   let firstSize = null;

  //   if (Number(product.variant_type_id) === Number(variant_type.Single)) {
  //     firstMetal = product.Product_Variants[0];
  //   } else if (
  //     Number(product.variant_type_id) === Number(variant_type.Double)
  //   ) {
  //     firstMetal = product.Product_Variants[0];
  //     firstSize = firstMetal?.Double_Variants?.[0] || null;
  //   }

  //   setActiveMetal(firstMetal);
  //   setActiveSize(firstSize);

  //   // Final selected variant
  //   setSelectedVariant(firstSize || firstMetal || null);
  // }, [product]);

  return (
    <>
      <section className="Cancel_order">
        <Breadcrumb_comp breadcrumbs={breadcrumbs} />
        <div className=" cancel_order_holder">
          <div className="container">
            <div className="title_holder">
              <div className="heading_holder">
                {/* <h4>
                  <Link to={`/order-details/${encodeId(order?.id)}`}>
                    <FontAwesomeIcon
                      className=" arrow_icon me-2"
                      icon={faCircleArrowLeft}
                    />
                  </Link>{" "}
                  Replace Order
                </h4> */}

                <h4>
                  <FontAwesomeIcon
                    className="arrow_icon me-2"
                    icon={faCircleArrowLeft}
                    onClick={() => navigate(-1)}
                    style={{ cursor: "pointer" }}
                  />{" "}
                  Replace Order
                </h4>
              </div>

              <div className="text_holder">
                <h6>Order ID #{order?.Product_Order?.invoice_no}</h6>
                <h5>{formatDateTime(order?.updatedAt)}</h5>
              </div>
            </div>

            <Replace_Order_list_table
              id={id}
              setActiveSize={setActiveSize}
              activeSize={activeSize}
              setSelectedVariant={setSelectedVariant}
              selectedVariant={selectedVariant}
              product={product}
              setActiveMetal={setActiveMetal}
              activeMetal={activeMetal}
              type="Replace"
              setError={setError}
              error={error}
              val={order}
              selectedItems={selectedItems}
              setSelectedItems={setSelectedItems}
            />

            <Select_reason_heading
              type="Replace"
              reason={reason}
              setError={setError}
              error={error}
              cancelReasonId={cancelReasonId}
              setCancelReasonId={setCancelReasonId}
              cancelReasonName={cancelReasonName}
              setCancelReasonName={setCancelReasonName}
            />

            <Reason_cancelling_field_holder
              selectedVariant={selectedVariant}
              id={id}
              product={product}
              type="Replace"
              setError={setError}
              error={error}
              order={order}
              cancelReason={cancelReason}
              setCancelReason={setCancelReason}
              selectedItems={selectedItems}
              cancelReasonId={cancelReasonId}
            />
          </div>
        </div>
      </section>
    </>
  );
}

export default Replace_order;
